<script setup lang="ts">
  // import { useDropZone } from '@vueuse/core'
  import { ref, useTemplateRef } from 'vue'
  import { useDashboardSearch } from '@/models/dashboard'
  import { useAuthStore } from '@/stores/auth'
  import TheSidebar from './_components/sidebar/the-sidebar.vue'
  import TheFooter from './_components/the-footer.vue'
  import TheNavbar from './_components/the-navbar.vue'
  import TheSearchbox from './_components/the-searchbox.vue'

  const auth = useAuthStore()

  const sidebarShow = ref(false)
  const toggleSidebarShow = () => {
    sidebarShow.value = !sidebarShow.value
  }

  const searchbox = useTemplateRef('searchbox')

  useDashboardSearch()

  // const refDropZone = ref<HTMLElement>()
  // const { isOverDropZone } = useDropZone(refDropZone)
  // watchEffect(() => {
  //   app.setUserDraggingFile(isOverDropZone.value)
  // })
</script>

<template>
  <div :class="{ 'sidebar-show': sidebarShow }">
    <template v-if="auth.user.id">
      <div class="screen">
        <div class="container px-container py-4">
          <the-navbar
            @toggle-sidebar="toggleSidebarShow"
            @open-search="searchbox?.open()" />
          <div class="min-h-container">
            <app-router-view />
            <!-- <router-view /> -->
          </div>
        </div>
      </div>

      <the-sidebar
        :show="sidebarShow"
        @toggle-sidebar-show="toggleSidebarShow"
        @open-search="searchbox?.open()" />

      <the-searchbox ref="searchbox" />
      <the-footer />
    </template>
  </div>
</template>

<style>
@reference "@/assets/styles/main.css";

:root {
  --container-padding: 1rem; /* 1rem 16px */
}

.px-container {
  @apply px-(--container-padding);
}

.container {
  margin-inline: auto;
}

/* Position & Size & Spacing */
.screen {
  /* this is the place for the router-view */
  @apply mt-(--navbar-height);
  @apply lg:pl-(--sidebar-width)!;

  /* Transition timing */
  @apply transition-all duration-500;
}

.min-h-container {
  min-height: calc(100vh - var(--navbar-height) - var(--footer-height) - 32px);
}

.page-filter-bar {
  @apply flex justify-end mb-6 gap-4 items-end;
}

</style>
